export default "__VITE_ASSET__BKXqH4dP__"